module.exports = __webpack_public_path__ + "static/media/icon-default.58efb9bc.svg";